import { render, staticRenderFns } from "./SummerPrepositions.vue?vue&type=template&id=bbb1a552&scoped=true&"
import script from "./SummerPrepositions.vue?vue&type=script&lang=js&"
export * from "./SummerPrepositions.vue?vue&type=script&lang=js&"
import style1 from "./SummerPrepositions.vue?vue&type=style&index=1&id=bbb1a552&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbb1a552",
  null
  
)

export default component.exports